module.exports = "<button (click)=\"showInfoDialog()\" mat-mini-fab>i</button>\n"